module.exports = __webpack_public_path__ + "2a8074baa319a88dc041458bb0af2cda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/works/Administrating-Eternity-2011-square.jpg
// module id = 874
// module chunks = 0